export enum HourlyBonusSectionType {
    left = "LEFT",
    middle = "MIDDLE",
    right = "RIGHT"
}